document.addEventListener('DOMContentLoaded', () => {
	const showcaseSections = document.querySelectorAll('.showcase-columns-section');
	showcaseSections.forEach(section => {
		const tabs = section.querySelectorAll('.tabs .tab');
		tabs.forEach(tab => {
			tab.addEventListener('click', ( event ) => {
				console.log("Hello");

				const selectedTab = event.target.getAttribute('data-tab');
				const selectedTabContent = section.querySelector(`#js-showcase-item-${selectedTab}`);
				if ( selectedTabContent ) {
					section.querySelectorAll('.js-slider-item').forEach(content => {
						content.classList.remove('active')
					});
					tabs.forEach(_tab => {
						_tab.classList.remove('active');
					});

					event.target.classList.add('active');


					selectedTabContent.classList.add('active');
				}
			})
		})
	});
});